import usePageWrapper from "PFCore/helpers/use_page_wrapper";
import { useAccount } from "PFCore/hooks/queries/accounts/use_account";
import { useFiltersConfigForm } from "PFCore/hooks/queries/saas_admin/config_forms/use_filters_config_form";
import React from "react";
import { useParams } from "react-router-dom";

import { FiltersConfigPage } from "./filters_config_page";

export const FiltersConfigController = () => {
  const { accountId } = useParams<{ accountId: string }>();

  const { data: account, isLoading: isAccountLoading } = useAccount({ accountId: Number(accountId) });

  const { data: filtersConfigTemplate, isLoading: isFiltersConfigTemplateLoading } =
    useFiltersConfigForm(accountId);

  const FiltersConfigPageWrapped = usePageWrapper(FiltersConfigPage);

  return (
    <FiltersConfigPageWrapped
      loading={isAccountLoading || isFiltersConfigTemplateLoading}
      account={account}
      filtersConfigTemplate={filtersConfigTemplate}
    />
  );
};
